export enum MaskingStyle {
  Full = 'full',
  Prefix = 'prefix',
  Suffix = 'suffix',
  Alternate = 'alternate',
}
